export default "__VITE_ASSET__DBLCpyAb__"